import { makeStyles, tokens } from '@fluentui/react-components';

export const useEntityStyles = makeStyles({
  activeIcon: {
    color: tokens.colorPaletteGreenForeground1,
    marginRight: '8px',
  },
  pausedIcon: {
    color: tokens.colorNeutralForeground3,
    marginRight: '8px',
  },
  entityButton: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px',
    border: 'none',
    backgroundColor: tokens.colorNeutralBackground1,
    cursor: 'pointer',
    textAlign: 'left',
    outline: 'none',
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground2,
    },
    '&:focus': {
      outline: 'auto',
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '8px',
  },
  name: {
    color: tokens.colorNeutralForeground1,
    marginBottom: '4px',
  },
  attributes: {
    color: tokens.colorNeutralForeground2,
  },
});

export const useAttachmentListStyles = makeStyles({
  attachmentItem: {
    alignItems: 'center',
  },
});

export const useEntitySelectionMenuStyles = makeStyles({
  entitySelectionMenuContainer: {
    height: '280px',
    maxWidth: '100%',
    overflow: 'hidden',
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
  },
  entityHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'center',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    paddingBottom: '8px',
  },
  entityTabs: {
    paddingRight: '64px',
  },
  tabList: {
    flex: '0 0 auto',
    marginBottom: '0 !important',
  },
  content: {
    paddingTop: '8px',
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
  },
  searchContainer: {
    flex: '1',
    display: 'flex',
    marginLeft: 'auto',
    '@media screen and (max-width: 800px)': {
      width: '100%',
      minWidth: '100%',
      marginLeft: 0,
    },
    '& input': {
      paddingLeft: tokens.spacingHorizontalS,
      background: 'transparent',
    },
  },
});

export const useChatInputWithEntitySelectionStyles = makeStyles({
  root: {
    '& .fai-ChatInput__inputWrapper': {
      minHeight: '108px',
    },
    '& .fai-ChatInput__attachments button.fai-AttachmentOverflowMenuButton': {
      border: 'none',
      background: '#F5F5F5',
    },
    '& .fai-ChatInput__count': {
      lineHeight: '32px !important',
    },
    '& button.fai-SendButton': {
      '&:disabled': {
        '& span icon': {
          backgroundColor: '#f0f0f0 !important',
          color: '#c2c2c2 !important',
          cursor: 'not-allowed',
        },
      },
    },
  },
  rootRefreshUI: {
    '& .fai-ChatInput__attachments': {
      marginLeft: '72px',
      paddingLeft: '4px',
      gridColumn: 2,
      gridRow: 4,
      height: '20px',
    },
    '& .fui-Tag__icon': {
      paddingLeft: '2px',
      width: 'unset',
    },
    '& .fai-AttachmentList__overflowMenuButton button': {
      height: '24px',
    },
  },
  chatInputWithAddIcon: {
    '& .fai-ChatInput__count': {
      marginLeft: '32px',
    },
  },
});

export const usePredefinedMessageStyles = makeStyles({
  addIcon: {
    height: 'fit-content',
    position: 'absolute',
    bottom: '5px',
  },
});
